<div class="beveled-picture" [ngStyle]="cssStyle"></div>
